import { useState, useEffect } from 'react';
import { FileSearch, Shield, CheckCircle } from 'lucide-react';

const ProcessSliderInsurance = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      icon: FileSearch,
      title: 'Starter Protection Policy',
      description: 'For: New brands, solo founders, and small businesses entering the market What it does: Provides foundational coverage to defend against certain trademark infringement claims, with limits suited for early-stage budgets. Includes access to an IP-focused legal counsel panel where available and helps cover basic attorney fees and court costs when defending your brand. Designed to protect cash flow while you build exposure.'
    },
    {
      icon: Shield,
      title: 'Growth Protection Policy',
      description: 'For: Scaling brands with higher market presence and risk exposure What it does: Delivers enhanced coverage limits for both defending against infringement accusations and enforcing your trademark against copycats. Supports legal action against competitors who misuse your brand, with tailored options for online, retail, and international operations. Balances stronger protection with cost-effective pricing for growing businesses.'
    },
    {
      icon: CheckCircle,
      title: 'Premium Protection Policy',
      description: 'For: Established brands with significant revenue and brand value to protect What it does: Offers comprehensive defence and enforcement coverage with the highest limits, including potential coverage for damages and indemnity obligations (policy-dependent). Built to protect investor confidence, long-term brand value, and operational continuity. Ideal for businesses that cannot afford litigation-driven downtime or financial strain.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <section className="py-20 bg-gray-50" data-testid="process-insurance-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Our IP Insurance Policies</h2>
        </div>

        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {steps.map((step, idx) => {
            const Icon = step.icon;
            return (
              <div
                key={idx}
                className={`bg-white rounded-2xl p-8 text-center card-hover transition-all duration-500 ${
                  currentStep === idx ? 'ring-primary-600 scale-105' : ''
                }`}
                data-testid={`process-insurance-step-${idx}`}
              >
                <div className="flex justify-center mb-6">
                  <div className="w-20 h-20 bg-secondary-100 rounded-full flex items-center justify-center">
                    <Icon className="w-10 h-10 text-secondary-600" />
                  </div>
                </div>
                {/* <div className="mb-4">
                  <span className="inline-block bg-secondary-100 rounded-full text-sm font-semibold mb-4">
                    Step {idx + 1}
                  </span>
                </div> */}
                <h3 className="text-2xl font-bold mb-4">{step.title}</h3>
                <p className="text-secondary-600 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>

        {/* Mobile View - Slider */}
        <div className="md:hidden">
          <div className="bg-white rounded-2xl p-8 text-center shadow-lg">
            {(() => {
              const Icon = steps[currentStep].icon;
              return (
                <>
                  <div className="flex justify-center mb-6">
                    <div className="w-20 h-20 bg-secondary-100 rounded-full flex items-center justify-center">
                      <Icon className="w-10 h-10 text-secondary-600" />
                    </div>
                  </div>
                  <div className="mb-4">
                    <span className="inline-block bg-secondary-100 rounded-full text-sm font-semibold mb-4">
                      Step {currentStep + 1}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{steps[currentStep].title}</h3>
                  <p className="text-secondary-600 leading-relaxed">{steps[currentStep].description}</p>
                </>
              );
            })()}
          </div>

          <div className="flex justify-center mt-8 space-x-2">
            {steps.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentStep(idx)}
                className={`w-3 h-3 rounded-full transition-all ${
                  currentStep === idx ? 'border-primary-600 w-8' : 'bg-gray-300'
                }`}
                data-testid={`process-insurance-dot-${idx}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSliderInsurance;
